import { toFlatField } from '../oasis-types';
export const EndocrineVersioned = {
    endocrine: { e1: { alias: 'endocrine', timepoint: ['soc', 'roc', 'rct', 'dsch'] } },
};
export const Endocrine = toFlatField(EndocrineVersioned);
